import { render, staticRenderFns } from "./Magnify.vue?vue&type=template&id=9bebb224"
import script from "./Magnify.vue?vue&type=script&lang=js"
export * from "./Magnify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports